import getAdditionalData from "@ecom/ui/helpers/getAdditionalData"
import formatToRequest from "@ecom/ui/helpers/formatToRequest"
import type { DadataFio } from "./dadata"

const fieldsType = {
  fio: "fio",
  birthDate: "date",
  phone: "phone",
}

export type ValuesToRequest = {
  additionalData: {
    cookie: string
    qsParams: any
    url: string
  }
  agree: string
  name: string
  patronymic: string
  phone: string
  surname: string
}

export type ValuesFromForm = {
  agree: boolean
  fio: DadataFio
  phone: string
}

export default function formatFieldsToRequest(values: ValuesFromForm): ValuesToRequest {
  const additionalData = getAdditionalData()
  const valuesToRequest = formatToRequest(values, fieldsType)
  const { fio } = valuesToRequest

  delete valuesToRequest.fio
  return { ...fio, ...valuesToRequest, additionalData }
}
